import { Box, Button, FormControl, IconButton, InputAdornment, MenuItem, Pagination, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ChartDonut from '../../components/ChartDonut'
import Loader from 'components/Loader'
import * as api from '../services/api'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ModalCalendar from 'components/modal/ModalCalendar'
import dayjs from 'dayjs'
import moment from 'moment/moment'
import StackedBarChart from 'components/StackedBarChart'
import top1 from '../../assets/icons/e-learning/top1.svg'
import top2 from '../../assets/icons/e-learning/top2.svg'
import top3 from '../../assets/icons/e-learning/top3.svg'

function ELearningOverview() {

  const [loading, setLoading] = useState(false)
  const [openCalendar, setOpenCalendar] = useState(false)
  const [disabledDay, setDisabledDay] = useState([])
  const [typeDate, setTypeDate] = useState('')

  const [search, setSearch] = useState('')
  const [dateStart, setDateStart] = useState(dayjs(moment(new Date()).startOf('month').format('YYYY-MM-DD')))
  const [dateEnd, setDateEnd] = useState(dayjs(moment(new Date()).endOf('month').format('YYYY-MM-DD')))
  const [status, setStatus] = useState('')
  const [optionStatus, setOptionStatus] = useState([
    {
      doc_status: "N",
      doc_status_name: "ลงทะเบียนเรียน"
    },
    {
      doc_status: "S",
      doc_status_name: "จบหลักสูตร"
    },
    {
      doc_status: "W",
      doc_status_name: "อยู่ระหว่างเรียน"
    },
  ])
  const [course, setCourse] = useState('')
  const [optionCourse, setOptionCourse] = useState([])

  const [dataSummary, setDataSummary] = useState([])
  const [summaryByGroup, setSummaryByGroup] = useState([])
  const [summaryByStatus, setSummaryByStatus] = useState([])

  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [showList, setShowList] = useState([])

  const [topCourseList, setTopCourseList] = useState([])
  const [listRegister, setListRegister] = useState([])

  const [department, setDepartment] = useState('')
  const [optionDepartment, setOptionDepartment] = useState([])

  const [eLearningCode, setELearningCode] = useState('')
  const [optionELearningCode, setOptionELearningCode] = useState([])

  useEffect(() => {
    analytics()
  }, [course, status, department, page])

  useEffect(() => {
    setPage(1)
  }, [course, status, department, search])

  useEffect(() => {
    topCourse()
    findCourse()
    findDepartment()
  }, [])

  useEffect(() => {
    ratioRegisterSuccess()
  }, [eLearningCode])

  const handlePageChange = (event, page) => {
    setPage(page)
  }

  const analytics = async () => {
    setLoading(true)
    let res = await api.analytics(moment(new Date(dateStart)).format('YYYY-MM-DD'), moment(new Date(dateEnd)).format('YYYY-MM-DD'), page, course == 'null' ? '' : course, department == 'null' ? '' : department, status == 'null' ? '' : status, search)
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        // console.log(res['data']['data'])
        let data = res['data']['data']
        setDataSummary(data)
        setSummaryByGroup(data['summary_by_group'])
        setSummaryByStatus(data['summary_by_status'])

        let sum = data['summary']['data'].sort((a, b) => new Date(b.register_date) - new Date(a.register_date));
        setShowList(sum)

        let pagging = res['data']['data']['summary']['pagging']
        setPage(pagging['page'])
        setTotalPage(pagging['totalPage'])

      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const convertDate = (dataDate) => {
    const date = new Date(dataDate)
    const optionDate = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
    const thaiLocale = 'th-TH';
    const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

    const newDate = `${formattedDate}`
    return newDate
  }

  const handleClickDate = (type) => {
    setTypeDate(type)
    setOpenCalendar(true)
  }

  const handleClickSearch = () => {
    analytics()
  }

  const handleFilterStatus = (e) => {
    let { value } = e.target
    setStatus(value)
  }

  const handleFilterCourse = (e) => {
    let { value } = e.target
    setCourse(value)
  }

  const handleFilterDepartment = (e) => {
    let { value } = e.target
    setDepartment(value)
  }

  const topCourse = async () => {
    setLoading(true)
    let res = await api.topCourse(moment(new Date(dateStart)).format('YYYY-MM-DD'), moment(new Date(dateEnd)).format('YYYY-MM-DD'))
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        // console.log(res['data']['data'])
        setTopCourseList(res['data']['data'])
      } else {
        console.log(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const ratioRegisterSuccess = async () => {
    setLoading(true)
    let res = await api.ratioRegisterSuccess(moment(new Date(dateStart)).format('YYYY-MM-DD'), moment(new Date(dateEnd)).format('YYYY-MM-DD'), eLearningCode)
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        // console.log(res['data']['data'])
        let data = res['data']['data'][0]['group_by_department']
        setListRegister(Object.values(data.reduce((acc, { department_code, department_name_short, doc_status, total }) => {
          if (!acc[department_code]) {
            acc[department_code] = {
              department_code,
              department_name_short,
              register_total: 0,
              progress_total: 0,
              success_total: 0,
              total: 0
            };
          }

          acc[department_code].total += total;
          if (doc_status === 'N') acc[department_code].register_total += total;
          if (doc_status === 'W') acc[department_code].progress_total += total;
          if (doc_status === 'S') acc[department_code].success_total += total;

          return acc;
        }, {})));
      } else {
        setListRegister([])
        console.log(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const clickExportExcel = async () => {
    setLoading(true)
    let res = await api.exportExcelElearning(moment(new Date(dateStart)).format('YYYY-MM-DD'), moment(new Date(dateEnd)).format('YYYY-MM-DD'))
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        let data = res['data']['data']['file_url']
        window.open(data, '_blank')
      } else {
        console.log(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const findDocument = async (code, group_code, course_code, pid) => {
    setLoading(true)
    let res = await api.findDocument(code, group_code, course_code, pid)
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        console.log(res['data']['data'])
        let data = res['data']['data']
        window.open(data['document_endpoint'], '_blank')
      } else {
        console.log(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const findCourse = async () => {
    setLoading(true)
    let res = await api.findCourse()
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        let data = res['data']['data'].sort((a, b) => new Date(b.created_date) - new Date(a.created_date));

        let option = []
        let opt = []
        for (let i = 0; i < data.length; i++) {
          if (data[i]) {
            option.push({
              key: data[i]['e_learning_code'],
              value: data[i]['e_learning_name']
            })
            opt.push({
              key: data[i]['e_learning_group_code'],
              value: data[i]['e_learning_group_name']
            })
          }
          const unique = [...new Map(option.map((m) => [m.key, m])).values()]
          setOptionELearningCode(unique)
          setELearningCode(unique[0]['key'])

          const unique1 = [...new Map(opt.map((m) => [m.key, m])).values()]
          setOptionCourse(unique1)
        }
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const findDepartment = async () => {
    setLoading(true)
    let res = await api.findDepartmentFixToken()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        let data = res['data']['data']
        let option = []

        data.forEach((item) => {
          const code = item?.department_code;
          const name = item?.department_name;
          if (code && name) {
            option.push({ key: code, label: name });
          }
        });

        const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
        setOptionDepartment(unique)
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const docStatusName = (name) => {
    const status = optionStatus.find(item => item.doc_status === name);
    return status?.doc_status_name
  }

  return (
    <>
      <Loader loading={loading} />
      {openCalendar &&
        <ModalCalendar
          onClose={() => { setOpenCalendar(false) }}
          onSubmit={() => {
            setOpenCalendar(false)
            analytics()

            topCourse()
            ratioRegisterSuccess()
          }}
          value={
            typeDate === 'start' ?
              dateStart ? dayjs(moment(dateStart['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
              :
              dateEnd ? dayjs(moment(dateEnd['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
          }
          setValue={(e) => {
            typeDate === 'start' ? setDateStart(e) : setDateEnd(e)
          }}
          disableDay={disabledDay}
        />
      }
      <Box sx={{ display: 'grid', gridGap: '10px' }}>
        <Box sx={{
          fontWeight: 600,
          color: "#478F96",
          "@media (max-width: 800px)": {
            textAlign: "center",
          },
        }}>ภาพรวมห้องเรียนออนไลน์</Box>

        <Box sx={{
          display: 'flex',
          gridGap: '10px',
          alignItems: 'center',
          "@media (max-width: 800px)": {
            display: 'grid'
          },
        }}>
          <Box sx={{ color: '#478F96' }}>หลักสูตรยอดนิยม 3 อันดับแรก</Box>
          <Box sx={{
            display: 'flex',
            gridGap: '10px',
            "@media (max-width: 800px)": {
              display: 'grid'
            },
          }}>
            <Box>
              <Box>เลือกวันที่เริ่ม</Box>
              <TextField
                fullWidth
                size='small'
                sx={{ ...SelectCss }}
                value={dateStart === '' ? 'เลือกวันที่เริ่ม' : convertDate(dateStart)}
                InputProps={{
                  inputProps: {
                    readOnly: true,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => { handleClickDate('start') }}
                      >
                        <CalendarTodayIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Box>
            <Box>
              <Box>เลือกวันที่สิ้นสุด</Box>
              <TextField
                fullWidth
                size='small'
                sx={{ ...SelectCss }}
                value={dateEnd === '' ? 'เลือกวันที่สิ้นสุด' : convertDate(dateEnd)}
                InputProps={{
                  inputProps: {
                    readOnly: true,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => { handleClickDate('end') }}
                      >
                        <CalendarTodayIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Box>
          </Box>
        </Box>

        {topCourseList.length > 0 ?
          <>
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              gridGap: '10px',
              "@media (max-width: 1000px)": {
                gridTemplateColumns: '1fr 1fr',
              },
              "@media (max-width: 600px)": {
                gridTemplateColumns: '1fr',
              }
            }}>

              {topCourseList.map((item, index) => (
                <Box sx={{
                  border: '1px solid #2F327D1A',
                  boxShadow: '2px 2px 10px #2F327D1A',
                  backgroundColor: '#ffffff',
                  borderRadius: '10px',
                  padding: '10px',
                  display: 'grid',
                  gridGap: '5px',
                  marginBottom: '20px',
                  "@media (max-width: 800px)": {
                    marginBottom: '10px',
                  },
                }} key={index}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                  }}>
                    <img src={index == 0 ? top1 : index == 1 ? top2 : top3} />
                    <Box sx={{ color: '#478F96', fontSize: '18px', fontWeight: 600 }}>อันดับที่ {index + 1}</Box>
                  </Box>
                  <Box sx={{ fontWeight: 600 }}>{item['e_learning_name']}</Box>
                  <Box sx={{ display: 'flex', gridGap: '10px' }}>
                    <Box sx={{ fontWeight: 600 }}>ผู้เข้าเรียน :</Box>
                    <Box>{item['total_register']} คน</Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </>
          :
          <Box sx={{ display: 'flex', justifyContent: 'center', margin: '25px', fontWeight: 600 }}>ไม่พบหลักสูตรยอดนิยม 3 อันดับแรก</Box>
        }

        <Box sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gridGap: '10px',
          "@media (max-width: 800px)": {
            gridTemplateColumns: '1fr',
          },
        }}>
          <Box sx={{
            border: '1px solid #478F96',
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            padding: '10px'
          }}>
            <Box>
              <Box sx={{ textAlign: 'center', color: '#478F96', fontWeight: 500 }}>จำนวนหลักสูตรในระบบ แยกตามหมวดหมู่</Box>
              <Box sx={{ margin: '10px' }}>
                <ChartDonut
                  type={'group'}
                  inform={summaryByGroup}
                  total={dataSummary['summary_by_group_total']}
                />
              </Box>
            </Box>
          </Box>
          <Box sx={{
            border: '1px solid #478F96',
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            padding: '10px'
          }}>
            <Box>
              <Box sx={{ textAlign: 'center', color: '#478F96', fontWeight: 500 }}>จำนวนการลงทะเบียนเรียน</Box>
              <Box sx={{ margin: '10px' }}>
                <ChartDonut
                  type={'status'}
                  inform={summaryByStatus}
                  total={dataSummary['summary_by_status_total']}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={{
          border: '1px solid #478F96',
          borderRadius: '10px',
          padding: '10px',
          display: 'grid',
          gridGap: '10px'
        }}>
          <Box sx={{ textAlign: 'center', color: '#478F96', fontWeight: 600 }}>จำนวนการลงทะเบียนในแต่ละหลักสูตร</Box>
          <Box>
            <Select
              size='small'
              sx={{ ...SelectCss }}
              value={eLearningCode}
              onChange={(e) => { setELearningCode(e.target.value) }}
            >
              {optionELearningCode.map((i, idx) => (
                <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
              ))}
            </Select>
          </Box>
          <Box>
            <StackedBarChart
              type={'register'}
              inform={listRegister}
            />
          </Box>
        </Box>

        <Box sx={{
          border: '1px solid #478F96',
          borderRadius: '10px',
          display: 'flex',
          padding: '5px'
        }}>
          <TextField
            fullWidth
            variant="standard"
            sx={{
              ...InputCSS
            }}
            InputProps={{
              disableUnderline: true,
            }}
            placeholder="พิมพ์เพื่อค้นหาข้อมูลชื่อผู้เข้าเรียน"
            value={search}
            onChange={(e) => { setSearch(e.target.value) }}
          />
          <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
        </Box>

        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          "@media (max-width: 800px)": {
            display: 'grid',
            gridGap: '10px'
          },
        }}>
          <Box sx={{
            display: 'flex',
            gridGap: '10px',
            "@media (max-width: 800px)": {
              display: 'grid'
            },
          }}>
            <Box>
              <Box>เลือกสถานะ</Box>
              <Select
                size="small"
                sx={{ ...SelectCss }}
                value={status || 'null'}
                onChange={(e) => { handleFilterStatus(e) }}
              >
                <MenuItem value='null'>สถานะทั้งหมด</MenuItem>
                {optionStatus.map((i, idx) => (
                  <MenuItem key={idx} value={i['doc_status']}>{i['doc_status_name']}</MenuItem>
                ))}
              </Select>
            </Box>

            <Box>
              <Box>เลือกหลักสูตร</Box>
              <Select
                size="small"
                sx={{ ...SelectCss }}
                value={course || "null"}
                onChange={(e) => { handleFilterCourse(e) }}
              >
                <MenuItem value='null'>หลักสูตรทั้งหมด</MenuItem>
                {optionCourse.map((i, idx) => (
                  <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
                ))}
              </Select>
            </Box>

            <Box>
              <Box>เลือกสังกัด</Box>
              <Select
                size="small"
                sx={{ ...SelectCss }}
                value={department || "null"}
                onChange={(e) => { handleFilterDepartment(e) }}
              >
                <MenuItem value='null'>สังกัดทั้งหมด</MenuItem>
                {optionDepartment.map((i, idx) => (
                  <MenuItem key={idx} value={i['key']}>{i['label']}</MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
          <Box sx={{
            display: 'flex',
            alignItems: 'end'
          }}>
            <Button
              variant='outained'
              sx={{ ...SelectCss }}
              onClick={() => { clickExportExcel() }}
            >Export Excel</Button>
          </Box>
        </Box>

        <Box sx={{
          overflow: 'auto'
        }}>
          <TableContainer sx={{ maxHeight: '700px' }}>
            <Table sx={{ minWidth: '1300px' }}>
              <TableHead sx={{ backgroundColor: '#C8EBEB' }}>
                <TableRow>
                  <TableCell rowSpan={2}>ยศ</TableCell>
                  <TableCell rowSpan={2}>ชื่อ</TableCell>
                  <TableCell rowSpan={2}>นามสกุล</TableCell>
                  <TableCell rowSpan={2}>สังกัด</TableCell>
                  <TableCell rowSpan={2}>หลักสูตร</TableCell>
                  <TableCell rowSpan={2}>วันที่ลงทะเบียน</TableCell>
                  <TableCell rowSpan={2}>สถานะ</TableCell>
                  <TableCell colSpan={2} align='center'>คะแนนสอบ</TableCell>
                  <TableCell rowSpan={2}>ใบประกาศ</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: 0 }} align='center'>ก่อน</TableCell>
                  <TableCell sx={{ padding: 0 }} align='center'>หลัง</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {showList.length > 0 ? (
                  showList.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ minWidth: '100px' }}>{item['titlename']}</TableCell>
                      <TableCell sx={{ minWidth: '120px' }}>{item['firstname']}</TableCell>
                      <TableCell>{item['lastname']}</TableCell>
                      <TableCell>{item['department_name']}</TableCell>
                      <TableCell>{item['e_learning_name']}</TableCell>
                      <TableCell>{convertDate(item['register_date'])}</TableCell>
                      <TableCell sx={{ minWidth: '130px' }}>{docStatusName(item['doc_status'])}</TableCell>
                      <TableCell align='center'>{item['score_pre_test'] === null ? '-' : item['score_pre_test']}</TableCell>
                      <TableCell align='center'>{item['score_post_test'] === null ? '-' : item['score_post_test']}</TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>
                        {item['doc_status'] === "S" ?
                          <div style={{
                            textDecoration: 'underline',
                            cursor: 'pointer'
                          }}
                            onClick={() => { findDocument(item['document_code'], item['e_learning_group_code'], item['e_learning_code'], item['pid']) }}
                          >สร้าง</div>
                          :
                          <div>-</div>
                        }

                      </TableCell>
                    </TableRow>
                  ))
                )
                  :
                  (
                    <TableRow>
                      <TableCell colSpan='8'>
                        <Box sx={{ textAlign: 'center' }}>ไม่มีข้อมูล</Box>
                      </TableCell>
                    </TableRow>
                  )
                }

              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          margin: 2
        }}>
          <Box sx={{ width: '100px' }}>
          </Box>
          <Stack spacing={2}>
            <Pagination
              count={totalPage}
              page={page}
              onChange={handlePageChange}
              shape="rounded"
              color="primary"
            />
          </Stack>
        </Box>

      </Box>
    </>
  )
}


export default ELearningOverview

const InputCSS = {
  padding: '5px',
  border: 'none',
  '&.MuiInputBase-root': {
    border: 'none'
  },
  '&.MuiInputBase-root:focus': {

  }
}

const SelectCss = {
  backgroundColor: '#C8EBEB',
  border: 'none',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
}